import { ECartType, EItemGroup, IEcommerceProduct, IEcommerceService } from '@services/ecommerceService';

export const convertEcommerceServiceToProduct = (service: IEcommerceService): IEcommerceProduct => ({
  productId: 0,
  productCode: service.productCode,
  productName: service.productName,
  vat: service.vat,
  brandName: '',
  price: Math.round((service.price + Number.EPSILON) * 100) / 100,
  fullPrice: service.fullPrice,
  quantity: service.quantity,
  variantName: '',
  stockAvailability: true,
  group: EItemGroup.SERVICE,
  cartType: ECartType.Cart,
  primaryCategories: {
    kind: 'Fragrances',
    category: 'Perfumes',
    subCategory: 'Women’s perfumes',
    type: 'Eaux de Parfum',
  },
});
